import type { Feature } from '@/userManagement/domain/entities/Feature';
import type { Permission } from '@/userManagement/domain/entities/Permission';
import type { PermissionFlagsWire } from '@/userManagement/domain/types/PermissionFlagsWire';

/**
 * Inbound: wire/template rows + feature catalog → {@link Permission} entities.
 * Outbound (UI matrix → REST flags): `application/mappers/permissionMatrixPayload.ts`.
 */
export function mapPermissionFlagsWireToPermissions(
  rows: PermissionFlagsWire[],
  featureById: Map<
    number,
    Pick<
      Feature,
      'name' | 'category' | 'supportsRead' | 'supportsWrite' | 'supportsDelete' | 'supportsCentralAccess' | 'supportsExcelExport'
    >
  >
): Permission[] {
  return rows.map((p) => {
    const feat = featureById.get(p.featureId);
    return {
      ...p,
      featureName: feat?.name ?? '',
      category: feat?.category ?? '',
      supportsRead: feat?.supportsRead !== false,
      supportsWrite: feat?.supportsWrite !== false,
      supportsDelete: feat?.supportsDelete !== false,
      supportsCentralAccess: feat?.supportsCentralAccess !== false,
      supportsExcelExport: feat?.supportsExcelExport !== false
    };
  });
}
